export class WhiteLabel {

  public id: number;
  public companyName: string;
  public cacheIcon: any;
  public cacheText: string;
  public defaultIcon: boolean;
  public allDomains: boolean;

}
